export const enum DatabaseTableEnum {
  locations = 'locations',
  contactedProperties = 'contacted-properties',
  savedProperties = 'saved-properties',
  autocompleteLocations = 'autocomplete-locations',
  autocompleteBrokers = 'autocomplete-brokers',
  autocompleteAgents = 'autocomplete-agents',
  filterSettings = 'filter-settings',
}
